import React from 'react'
import SearchUi from './SearchUi'

function Search({setTableQaury,tableQaury,placeHolder,buttonName,buttonBoolean,linkPath, backgroundColor}) {
  return (
    <SearchUi setTableQaury={setTableQaury} tableQaury={tableQaury} placeHolder={placeHolder}  buttonName={buttonName}
    buttonBoolean={buttonBoolean} linkPath={linkPath} backgroundColor={backgroundColor}/>
  )
}

export default Search